import { CheckCircle, Loader2, AlertCircle, Clock } from 'lucide-react';
import { Progress } from '@/components/ui/progress';
import type { JobStatus } from '@/types/forensics';

const STATUS_CONFIG: Record<JobStatus, { label: string; icon: React.ReactNode; className: string }> = {
  queued: { label: 'Queued', icon: <Clock className="h-5 w-5" />, className: 'text-muted-foreground' },
  preprocessing: { label: 'Preprocessing', icon: <Loader2 className="h-5 w-5 animate-spin" />, className: 'text-blue-600' },
  running: { label: 'Running Analysis', icon: <Loader2 className="h-5 w-5 animate-spin" />, className: 'text-blue-600' },
  aggregating: { label: 'Aggregating Results', icon: <Loader2 className="h-5 w-5 animate-spin" />, className: 'text-blue-600' },
  complete: { label: 'Analysis Complete', icon: <CheckCircle className="h-5 w-5" />, className: 'text-green-600' },
  partial_complete: { label: 'Partial Results', icon: <AlertCircle className="h-5 w-5" />, className: 'text-orange-500' },
  failed: { label: 'Analysis Failed', icon: <AlertCircle className="h-5 w-5" />, className: 'text-red-500' },
  canceled: { label: 'Canceled', icon: <AlertCircle className="h-5 w-5" />, className: 'text-muted-foreground' },
};

interface JobStatusBannerProps {
  status: JobStatus;
  progressPct: number;
  errorMessage?: string;
}

export default function JobStatusBanner({ status, progressPct, errorMessage }: JobStatusBannerProps) {
  const config = STATUS_CONFIG[status];

  return (
    <div className="space-y-2">
      <div className={`flex items-center gap-2 ${config.className}`}>
        {config.icon}
        <span className="text-lg font-semibold">{config.label}</span>
      </div>
      <Progress value={progressPct} />
      {errorMessage && <p className="text-sm text-destructive">{errorMessage}</p>}
    </div>
  );
}
